import { service } from '@maia/cart';

export function getCartQueryOptions(
  params: Parameters<typeof service.getCart>[number],
) {
  return {
    queryKey: ['cart', params.cartGuid],
    queryFn: async () => service.getCart(params),
  };
}
